import request from "./request";
import config from '@/config'
const baseUrl = config.service.orderUrl

export default {
	getTrainH5(data){
	    return request({
	        url: `${baseUrl}/order/getTrainH5`,
	        method: 'post',
			data
	    })
	},
    generateLinkWithoutCheckOrder(data) {
		return request({
		    url: `${baseUrl}/order/getMiniProgramLink`,
		    method: 'post',
			data
		})
	},
    getOrderInfo() {
        let userId = localStorage.getItem("userId");
        return request({
            url: `${baseUrl}/order/getOrderListByUserId?userId=${userId}`,
            method: 'get'
        })
    },
    getProductList() {
        let userId = localStorage.getItem("userId");
		let channel = localStorage.getItem("pa.channel");
        return request({
            url: `${baseUrl}/product/getListProductListByChannel?channel=${channel}`,
            method: 'get'
        })
    },
    getOrderByOrderId(orderId) {
        return request({
            url: `${baseUrl}/order/getOrderByOrderId?orderId=${orderId}`,
            method: 'get'
        })
    },
    getProductInfo(productId){
        let channel = localStorage.getItem("pa.channel");
        return request({
            url: `${baseUrl}/product/getProductInfo?productId=${productId}&channel=${channel}`,
            method: 'get'
        })
    },
    checkPay(orderId){
        return request({
            url: `${baseUrl}/order/payed/check?orderId=${orderId}`,
            method: 'get'
        })
    },
    getOrderDetail(orderId){
        return request({
            url: `${baseUrl}/order/queryOrderDetail`,
            method: 'post',
            data: {
                orderId
            }
        })
    },
    getAgentInfo(agentId){
        return request({
            url: `${baseUrl}/agent/getAgentInfo`,
            method: 'post',
            data: {
                agentId
            }
        })
    },
    createAgentWithdraw(agentId){
        return request({
            url: `${baseUrl}/agent/createAgentWithdraw`,
            method: 'post',
            data: {
                agentId
            }
        })
    },
    getAgentWithdrawInfo(agentId){
        return request({
            url: `${baseUrl}/agent/getAgentWithdrawInfo`,
            method: 'post',
            data: {
                agentId
            }
        })
    },
    getAgentOrderInfo(agentId){
        return request({
            url: `${baseUrl}/agent/getAgentOrderInfo`,
            method: 'post',
            data: {
                agentId
            }
        })
    },
    getBannelByChannel(channel,versionNumber){
        let headers = {}
        if(versionNumber){
            headers = {versionNumber}
        }
        return request({
            url: `${baseUrl}/banner/getBannelByChannel?channel=${channel}`,
            method: 'get',
            headers
        })
    },
	getAllOrderByUserIdAndUnionId(data){
	    return request({
	        url: `${baseUrl}/order/getAllOrderByUserIdAndUnionId`,
	        method: 'post',
			data
	    })
	},
	getLuckyDrawInfo(data){
		return request({
			url : `${baseUrl}/luckyDraw/getLuckyDrawH5Info`,
			method: 'post', 
			data
		})
	},
	updateLuckyDrawStatus(data){
		return request({
			url : `${baseUrl}/luckyDraw/updateH5LuckyDrawStatus`, 
			method: 'post',
			data
		})
	},
	getBulletChat(data){
		return request({
			url : `${baseUrl}/luckyDraw/getBulletChat`, 
			method: 'post',
			data
		})
	},
	getPrizes(data){
		return request({
			url : `${baseUrl}/luckyDraw/getPrizes`, 
			method: 'post',
			data
		})
	},
	getMiniProgramLink(data) {
		return request({
		    url: `${baseUrl}/order/getMiniProgramLink`,
		    method: 'post',
			data
		})
	},
	checkG3Order() {
		return request({
		    url: `${baseUrl}/order/getG3OrderByUserId`,
		    method: 'get'
		})
	},
	getCurrentGroupImageByChannel(channel) {
		        let userId = localStorage.getItem("userId");
		return request({
		    url: `${baseUrl}/activity/getCurrentGroupImg?channel=${channel}`+'&userId='+userId,
		    method: 'get'
		})
	},
    // 增加scs可使用次数
    addScsUse(data) {
        return request({
            url: baseUrl + '/order/ytj/scs/use',
            method: 'POST',
            data
        });
    },
	findQybAgent(userName) {
		return request({
		    url: `${baseUrl}/agent/findQybAgent?userName=${userName}`,
		    method: 'POST'
		})
	},
	getClinicTrialCodeByUserId(userId) {
	    return request({
	        url: baseUrl + `/hospital/getClinicTrialCodeByUserId?userId=${userId}`,
	        method: 'POST',
	    });
	},
	bindClinicTrialCode(data) {
	    return request({
	        url: baseUrl + '/hospital/bindClinicTrialCode',
	        method: 'POST',
	        data
	    });
	},
	getChannelByChannel (channel){
		return request({
		    url: baseUrl + '/channel/getChannelByChannel?channel='+channel,
		    method: 'POST',
		});
	},
	getChannelBackLink (channel){
		return request({
		    url:  baseUrl + '/activity/getChannelBackLink?channel='+channel,
		    method: 'GET',
		});
	},
	createFreeOrder(data){
	    return request({
	        url: `${baseUrl}/order/create/free`,
	        method: 'post',
			data
	    })
	},
	activityAttendance(data){
	    return request({
	        url: `${baseUrl}/user/activity/attendance/add`,
	        method: 'post',
			data
	    })
	},
}

